import {
  LayoutDashboard,
  Users,
  Upload,
  FileSearch,
  GitCompare,
  ShieldAlert,
  BadgeCheck,
  HelpCircle,
  UserPlus,
  CheckCircle2,
  ListChecks,
  Briefcase,
  ClipboardList,
  Settings,
  CloudDownload,
  FolderOpen,
  Database,
  Wrench,
  Calendar,
  MessageSquare,
  BarChart3,
} from "lucide-react";

/** Mapa iconKey → Lucide (compartido por Layout y hubs de módulo). */
export const MODULE_NAV_ICONS = {
  panel: LayoutDashboard,
  clients: Users,
  upload: Upload,
  file: FileSearch,
  compare: GitCompare,
  shield: ShieldAlert,
  validate: BadgeCheck,
  help: HelpCircle,
  users: UserPlus,
  check: CheckCircle2,
  listchecks: ListChecks,
  briefcase: Briefcase,
  catalog: ClipboardList,
  settings: Settings,
  cloud: CloudDownload,
  reports: ClipboardList,
  folder: FolderOpen,
  database: Database,
  tramites: ClipboardList,
  wrench: Wrench,
  calendar: Calendar,
  message: MessageSquare,
  chart: BarChart3,
};

export function resolveModuleNavIcon(iconKey, fallback = LayoutDashboard) {
  return MODULE_NAV_ICONS[iconKey] || fallback;
}
